// adding some validations logic for prize insurance form
import { required, email, minLength, numeric, between } from 'vuelidate/lib/validators'

export const FORM_PRIZE_VALIDATIONS = {
  userDataForm: {
    companyname: {
      required,
      minLength: minLength(2)
    },
    address: {
      required,
      minLength: minLength(15)
    },
    phonenumber: {
      required,
      numeric,
      minLength: minLength(10)
    },
    email: {
      required,
      email
    },
    zipcode: {
      required,
      numeric,
      minLength: minLength(5),
      between: between(10000, 99999)
    },
    namepromotionevent: {
      required,
      minLength: minLength(5)
    },
    descriptionpromotionevent: {
      required,
      minLength: minLength(50)
    },
    valueinsured: {
      required,
      numeric,
      minLength: minLength(3)
    },
    officialrules: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/validations/formPrize.js